import React, { useState, useEffect, useRef } from 'react';
import { useWebSocket } from '../context/WebSocketProvider'
import { useParams, ScrollRestoration, useNavigate, useLocation } from 'react-router-dom';
// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
import API from '../API'
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import ClubHeader from './ClubHeader';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid'
import List from './List'
import { MessageDiv } from './MessageBox/MessageBox.styles';

// Hook
import useAuth from '../hooks/useAuth';
import { useMessageListFetch } from '../hooks/useMessageListFetch'

// Image

import Grid from './Grid';
import PdfView from './PdfView';
import { MessageBox } from './MessageBox';

let renderCount = 0

const MessageList = () => {
  const auth = useAuth();
  const user = auth?.auth?.user;
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "./";
  const [messageInput, setMessageInput] = useState("");
  const { state, loading, error, setSearchValue, setLoading, setTrigger } = useMessageListFetch();
  const { socket, messages } = useWebSocket()
  const messagesEndRef = useRef(null);
  const onSubmit = (e) => {
    e.preventDefault();
    if (socket && messageInput.trim()) {
      socket.send(messageInput);
      setMessageInput(""); // Clear input after sending
    }
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });


  }, [messages]);

  const handleClick = async (e) => {

    try {

      // eslint-disable-next-line no-restricted-globals
      const confirmation = confirm("Are you sure you want to Delete this document? This action cannot be overturned!")
      if (confirmation) {

        console.log("Sukses, die employee gaan delete word hier")
        await API.deleteFile(e.target.id, auth.auth.accessToken)

        setTrigger(true)


      } else {
        return
      }


    } catch (error) {
      console.log(error)
    }

    console.log("gekliek op" + e.target.id)
    console.log(auth.auth.user.username)

  }



  const username = auth.auth.user.username

  const access = auth.auth.user.userRole
  // console.log(besluit.besluit[0].besluit)
  console.log(state)
  console.log(messages)

  renderCount++
  return (
    <>

      <Header username={username} role={access} destination={from}></Header>
      <MessageBox></MessageBox>



      {/* <h1>RenderCount {renderCount/2}</h1> */}
      <div className='ListHead'>
        <SearchBar key={1} setSearchValue={setSearchValue}></SearchBar>

      </div>
      
      
        {messages.map((message) => (


          <>

            <MessageDiv user={user.username === message.sender}>
              <div>{message.sender}</div>:
              <div>{message.message}</div>
            </MessageDiv>





          </>
        ))}
       
        <div style={{ height: '80px' }} ref={messagesEndRef} />
        
      {/* <div>{`Message count ${state.messages?.length}`}</div>
       
        {loading ? <h1>...Loading</h1> : ""}

        {state.messages.reverse().map((item) => (

          <>
          <MessageDiv user={user.username===item.sendUser.username}>
            <div>{item.sendUser.username}</div>
            <div>{item.message}</div>
            <Knoppie
              clickable={true}
              text={"Delete"}

              employeeid={item._id}
              callback={handleClick}
            >

            </Knoppie>
          </MessageDiv>

          

            </>
       
        ))} */}



      <form onSubmit={onSubmit} className="MessageForm">
        <input
          className="inputsize"
          type="text"
          value={messageInput}
          onChange={(e) => setMessageInput(e.target.value)}
        />
        <button type="submit">Send Message</button>
      </form>






    </>
  );
};

export default MessageList;

